import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';
import Computer, { AgentType } from 'mbs-ui-shared@models/Computer';
import { ComputerBasedModal } from 'mbs-ui-shared@models/ComputersModals';

const connectWithTokenSupportsAgentVersion = 340;
const backupWithTokenSupportsAgentVersion = 770;

@UntilDestroy()
@Component({
  selector: 'mbs-computers-auth-required-modal-component',
  templateUrl: './computers-auth-required-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    HelpLinkDirective,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class ComputersAuthRequiredModalComponent implements ComputerBasedModal {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly alertType = MbsPopupType;
  public computer: Computer;

  public get needUpgradeBackupAgent(): boolean {
    return (
      Computer.isWindows(this.computer) &&
      Computer.hasAgent(this.computer, AgentType.Backup) &&
      !Computer.IsSupportedAgentVersion(this.computer, AgentType.Backup, backupWithTokenSupportsAgentVersion)
    );
  }

  public get reAuthRequired(): boolean {
    return (
      Computer.isWindows(this.computer) &&
      !Computer.hasAgent(this.computer, AgentType.Backup) &&
      Computer.hasAgent(this.computer, AgentType.RA) &&
      Computer.IsSupportedAgentVersion(this.computer, AgentType.RA, connectWithTokenSupportsAgentVersion)
    );
  }

  public get computerName(): string {
    return Computer.getComputerName(this.computer);
  }
}
